<template>
  <Box class="box-wrapper">
    <template v-slot:header>
      <div>{{ $t('common.withdrawalAmount') }}</div>
      <DoubleArrow />
      <div>{{ $t('common.requiredLot') }}</div>
    </template>
    <template v-slot:body>
      <div class="exchangetable-content">
        <div>
          <div class="input-label">{{ $t('common.withdrawalAmount') }}</div>
          <InputWithAdder
            :value="amount"
            @input="onDebounceAmountInput"
            :forceUpdate="forceUpdateAmountInput"
            :step="100"
            @count="onAmountInput"
            :format="true"
            :placeholder="$t('common.input')"
            :error="isError"
          />
        </div>
        <div>
          <div class="input-label">{{ $t('common.requiredLot') }}</div>
          <InputWithAdder
            :value="lot"
            @input="onDebounceLotInput"
            :forceUpdate="forceUpdateLotInput"
            :step="30"
            @count="onLotInput"
            :placeholder="$t('common.input')"
            :error="isError"
          />
        </div>
        <div>
          <Button
            class="redeem-btn"
            v-bind="isError ? errBtnStyle : redeemBtnStyle"
            @click="redeemAction"
            :disabled="isError"
            >{{ $t('common.redeem') }}</Button
          >
          <div class="warning">{{ $t('promotion.redepositBonus.tradeWarning') }}</div>
        </div>
      </div>
    </template>
  </Box>
</template>

<script>
import Box from '@/components/widgets/Box.vue';
import DoubleArrow from '@/components/icon/DoubleArrow.vue';
import InputWithAdder from '@/components/interact/InputWithAdder.vue';
import debounce from 'lodash.debounce';
import Button from '@/components/interact/Button.vue';
import { HIGHLIGHT_COLOR, BLACK_COLOR } from '@/constants/style';

const redeemBtnStyle = {
  bgColor: HIGHLIGHT_COLOR,
  color: '#fff',
  borderRadius: '29px',
  padding: '6px 48px',
  fontSize: '18px',
  lineHeight: 'normal',
  fontWeight: 500
};

const errBtnStyle = {
  bgColor: '#e5e5e5',
  color: BLACK_COLOR,
  borderRadius: '29px',
  padding: '6px 48px',
  fontSize: '18px',
  lineHeight: 'normal',
  fontWeight: 500
};

export default {
  name: 'ExchangeTable',
  props: {
    remainingLots: {
      type: Number,
      default: 0
    },
    remainingCredit: {
      type: Number,
      default: 0
    }
  },
  components: {
    Box,
    DoubleArrow,
    InputWithAdder,
    Button
  },
  data() {
    return {
      amount: 0,
      lot: 0,
      forceUpdateAmountInput: 0,
      forceUpdateLotInput: 0,
      showWithdrawalPopOut: false,
      redeemBtnStyle,
      errBtnStyle
    };
  },
  computed: {
    isError() {
      let res = this.lot > this.remainingLots || this.lot === 0 || this.amount > this.remainingCredit;
      return res;
    }
  },
  mounted() {
    this.onAmountInput(this.remainingCredit < 100 ? this.remainingCredit : 100);
  },
  methods: {
    resetForm() {
      this.amount = 0;
      this.lot = 0;
    },
    isValid(value) {
      return !isNaN(value) && value >= 0;
    },
    onAmountInput(value) {
      if (!this.isValid(value)) {
        this.resetForm();
      } else {
        this.amount = value;
        this.lot = Math.ceil(value / 100) * 30;
      }
      this.forceUpdateAmountInput++;
    },
    onLotInput(value) {
      if (!this.isValid(value)) {
        this.resetForm();
      } else {
        this.lot = value - (value % 30);
        this.amount = (this.lot / 30) * 100;
      }
      this.forceUpdateLotInput++;
    },
    onDebounceAmountInput: debounce(function (value) {
      this.onAmountInput(value);
    }, 1000),
    onDebounceLotInput: debounce(function (value) {
      this.onLotInput(value);
    }, 500),
    redeemAction() {
      this.$emit('redeem', { amount: this.amount, lots: this.lot });
    }
  }
};
</script>

<style lang="scss" scoped>
.exchangetable-content {
  padding: 0px 30px;

  > div {
    margin: 32px 0;
  }

  & .input-label {
    margin-bottom: 11px;
    font-size: 18px;
    color: $HIGHLIGHT_COLOR;
  }

  & .warning {
    margin-top: 4px;
    size: 12px;
    color: #e91545;
  }
}
</style>
